import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import config from "@/assets/configs/config";

import {Layout, Menu} from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';

Vue.use(Layout)
Vue.use(Menu)


Vue.config.productionTip = false
Vue.prototype.$config = config

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
